
const CopyRightIcon = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22C6.477 22 2 17.523 2 12Z" stroke="#5D5F62" strokeWidth="1.5" />
            <path d="M14 15.667C13.4559 15.8888 12.8736 16.002 12.286 16C9.919 16 8 14.21 8 12C8 9.79 9.919 8 12.286 8C12.896 8 13.475 8.119 14 8.333" stroke="#5D5F62" strokeWidth="1.5" strokeLinecap="round" />
        </svg>

    )
}

export default CopyRightIcon;